import App from "../../../package.json";

// * constant value
export const PACKAGE_NAME = App.name;
export const IS_APP_PRODUCTION = process.env.REACT_APP_PRODUCTION === "true";
export const APP_VERSION = App.version;
export const API_URL = process.env.REACT_APP_API_URL;
export const APP_NAME = PACKAGE_NAME.replace(/-/g, " ");
export const NO_IMAGE_AVAILABLE = "https://faculty.eng.ufl.edu/non-traditional-manufacturing-laboratory/wp-content/uploads/sites/60/2015/11/img-placeholder.png";